module.exports = require('./dist/Tooltip.js');



//////////////////
// WEBPACK FOOTER
// ./~/dibs-react-tooltip/index.js
// module id = 275
// module chunks = 4 6 7 8 9 10 11 12 13 14 15 16 17 18 20 21 22 23 26 30 31 32 56 57